import L from 'leaflet';

export const DEFAULT_MAPBOX_TOKEN = 'pk.eyJ1IjoiZ3JlZW5mdXR1cmVjZW8iLCJhIjoiY2tucmk5bW42MG9ydDMwcGZrMHRkYmQ3MCJ9.bfY8CoM_h8J5d7Bz7avpMA';

export const MAPBOX_STYLES = [
  {
    id: 'mapbox/light-v11',
    name: 'Mapbox Light',
    styleUrl: 'mapbox://styles/mapbox/light-v11',
    description: 'A minimal, light-colored basemap suited for overlaying data visualizations.',
    previewUrl: 'https://api.mapbox.com/styles/v1/mapbox/light-v11.html?access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY203eXd1a3ZzMGV1ejJrcHRvdnVoYng0NCJ9.NzlqpAcLHejzezQqazzI-w',
    docUrl: 'https://docs.mapbox.com/map-styles/reference/light/',
    badge: 'Recommandé (Défaut)',
    accentColor: '#38bdf8',
    previewBg: '#f1f5f9',
    previewFg: '#334155'
  },
  {
    id: 'mapbox/streets-v12',
    name: 'Mapbox Streets',
    styleUrl: 'mapbox://styles/mapbox/streets-v12',
    description: 'A general-purpose street map featuring roads, transit, and place labels.',
    previewUrl: 'https://api.mapbox.com/styles/v1/mapbox/streets-v12.html?access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY203eXd1a3ZzMGV1ejJrcHRvdnVoYng0NCJ9.NzlqpAcLHejzezQqazzI-w',
    docUrl: 'https://docs.mapbox.com/map-styles/reference/streets/',
    accentColor: '#3b82f6',
    previewBg: '#e2e8f0',
    previewFg: '#1e293b'
  },
  {
    id: 'mapbox/outdoors-v12',
    name: 'Mapbox Outdoors',
    styleUrl: 'mapbox://styles/mapbox/outdoors-v12',
    description: 'A terrain-focused style with hiking routes, contour lines, and natural features.',
    previewUrl: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v12.html?access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY203eXd1a3ZzMGV1ejJrcHRvdnVoYng0NCJ9.NzlqpAcLHejzezQqazzI-w',
    docUrl: 'https://docs.mapbox.com/map-styles/reference/outdoors/',
    accentColor: '#22c55e',
    previewBg: '#ecfdf5',
    previewFg: '#065f46'
  },
  {
    id: 'mapbox/dark-v11',
    name: 'Mapbox Dark',
    styleUrl: 'mapbox://styles/mapbox/dark-v11',
    description: 'A minimal, dark-colored basemap suited for overlaying data visualizations.',
    previewUrl: 'https://api.mapbox.com/styles/v1/mapbox/dark-v11.html?access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY203eXd1a3ZzMGV1ejJrcHRvdnVoYng0NCJ9.NzlqpAcLHejzezQqazzI-w',
    docUrl: 'https://docs.mapbox.com/map-styles/reference/dark/',
    accentColor: '#a855f7',
    previewBg: '#0f172a',
    previewFg: '#94a3b8'
  },
  {
    id: 'mapbox/satellite-streets-v12',
    name: 'Mapbox Satellite Streets',
    styleUrl: 'mapbox://styles/mapbox/satellite-streets-v12',
    description: 'Satellite imagery with road and place labels overlaid.',
    previewUrl: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v12.html?access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY203eXd1a3ZzMGV1ejJrcHRvdnVoYng0NCJ9.NzlqpAcLHejzezQqazzI-w',
    docUrl: 'https://docs.mapbox.com/map-styles/reference/satellite-streets/',
    accentColor: '#06b6d4',
    previewBg: '#134e4a',
    previewFg: '#ccfbf1'
  },
  {
    id: 'mapbox/satellite-v9',
    name: 'Mapbox Satellite',
    styleUrl: 'mapbox://styles/mapbox/satellite-v9',
    description: 'Global satellite and aerial imagery with no labels.',
    previewUrl: 'https://api.mapbox.com/styles/v1/mapbox/satellite-v9.html?access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY203eXd1a3ZzMGV1ejJrcHRvdnVoYng0NCJ9.NzlqpAcLHejzezQqazzI-w',
    docUrl: 'https://docs.mapbox.com/map-styles/reference/satellite/',
    accentColor: '#14b8a6',
    previewBg: '#064e3b',
    previewFg: '#a7f3d0'
  },
  {
    id: 'mapbox/navigation-day-v1',
    name: 'Mapbox Navigation Day',
    styleUrl: 'mapbox://styles/mapbox/navigation-day-v1',
    description: 'A high-contrast style optimized for in-vehicle navigation in daytime conditions.',
    previewUrl: 'https://api.mapbox.com/styles/v1/mapbox/navigation-day-v1.html?access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY203eXd1a3ZzMGV1ejJrcHRvdnVoYng0NCJ9.NzlqpAcLHejzezQqazzI-w',
    docUrl: 'https://docs.mapbox.com/map-styles/reference/navigation-day/',
    accentColor: '#f59e0b',
    previewBg: '#fef3c7',
    previewFg: '#92400e'
  },
  {
    id: 'mapbox/navigation-night-v1',
    name: 'Mapbox Navigation Night',
    styleUrl: 'mapbox://styles/mapbox/navigation-night-v1',
    description: 'A high-contrast style optimized for in-vehicle navigation in nighttime conditions.',
    previewUrl: 'https://api.mapbox.com/styles/v1/mapbox/navigation-night-v1.html?access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY203eXd1a3ZzMGV1ejJrcHRvdnVoYng0NCJ9.NzlqpAcLHejzezQqazzI-w',
    docUrl: 'https://docs.mapbox.com/map-styles/reference/navigation-night/',
    accentColor: '#818cf8',
    previewBg: '#1e1b4b',
    previewFg: '#c7d2fe'
  }
];

export function getSavedMapboxStyle() {
  try {
    const saved = localStorage.getItem('loops_mapbox_style');
    if (saved && MAPBOX_STYLES.some(s => s.id === saved)) {
      return saved;
    }
  } catch (e) {}
  return 'mapbox/light-v11';
}

export function setSavedMapboxStyle(styleId) {
  try {
    localStorage.setItem('loops_mapbox_style', styleId);
    window.dispatchEvent(new CustomEvent('loops_map_style_changed', { detail: { style: styleId } }));
  } catch (e) {}
}

/**
 * Creates a Leaflet tile layer using Mapbox styles with Retina @2x resolution.
 * 
 * @param {'pale' | 'dark' | 'default' | string} themeOrStyle 
 * @param {Object} options Additional Leaflet tileLayer options
 * @returns {L.TileLayer}
 */
export function createTileLayer(themeOrStyle = 'default', options = {}) {
  const token = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_MAPBOX_TOKEN) || DEFAULT_MAPBOX_TOKEN;

  let styleId = getSavedMapboxStyle();
  if (themeOrStyle === 'dark') {
    styleId = 'mapbox/dark-v11';
  } else if (themeOrStyle && themeOrStyle !== 'pale' && themeOrStyle !== 'default' && themeOrStyle !== 'standard') {
    styleId = themeOrStyle;
  }

  const mapboxUrl = `https://api.mapbox.com/styles/v1/${styleId}/tiles/256/{z}/{x}/{y}@2x?access_token=${token}`;
  const attribution = '&copy; <a href="https://www.mapbox.com/about/maps/" target="_blank" rel="noopener noreferrer">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>';

  return L.tileLayer(mapboxUrl, {
    maxZoom: 20,
    tileSize: 512,
    zoomOffset: -1,
    attribution,
    ...options
  });
}
